import { KeyboardArrowDown, LockOutlined } from '@mui/icons-material';
import { FormControl, InputLabel, MenuItem, OutlinedInput, Select } from '@mui/material';
import { useRef } from 'react';
import styled from 'styled-components';
import { border, darkerBackground, darkText, primaryBlue, primaryRed } from '../models/colors';

const id = Math.floor(Math.random() * Math.floor(Number.MAX_SAFE_INTEGER)).toString();

const DisabledIcon = styled((props: any) => <LockOutlined {...props} />)`
	top: calc(50% - 12px);
	right: 0;
	color: rgba(0, 0, 0, 0.54);
	position: absolute;
	pointer-events: none;
`;

const KeyboardArrowDownIcon = styled((props: any) => <KeyboardArrowDown {...props} />)`
	top: calc(50% - 12px);
	right: 8px;
	color: rgba(0, 0, 0, 0.54);
	position: absolute;
	pointer-events: none;
`;

export const StyledSelect = styled(({ value, label, name, onChange, disabled, menuItems, ...rest }: any) => {
	const labelRef = useRef<HTMLLabelElement>(null);

	return (
		<FormControl variant="outlined" fullWidth disabled={disabled || false} {...rest}>
			<InputLabel
				htmlFor={id}
				classes={{
					root: 'inputRoot',
					focused: 'inputFocused',
					error: 'inputError',
				}}
				ref={labelRef}
			>
				{label}
			</InputLabel>
			<Select
				IconComponent={disabled ? () => <DisabledIcon /> : () => <KeyboardArrowDownIcon />}
				value={value}
				onChange={onChange}
				input={
					<OutlinedInput
						name={name}
						id={id}
						label={label}
						classes={{
							root: 'root',
							input: 'input',
							notchedOutline: 'notchedOutline',
							focused: 'focused',
							error: 'error',
							disabled: 'disabled',
						}}
					/>
				}
			>
				{menuItems.map((item: { id: string; name: string }, idx: number) => (
					<MenuItem key={idx} value={item.id}>
						{item.name}
					</MenuItem>
				))}
			</Select>
		</FormControl>
	);
})`
	@media only screen and (min-width: 601px) {
		margin-bottom: 36px;
	}
	& .input {
		color: ${darkText};
		caret-color: ${primaryBlue};
		font-family: 'Roboto', sans-serif;
	}
	& .notchedOutline {
		border-width: 2px;
		border-color: ${p => (p.disabled ? darkerBackground : border)};
	}
	& .focused .notchedOutline {
		border-color: ${primaryBlue};
	}
	& .error .notchedOutline {
		border-color: ${primaryRed};
	}
	& .disabled .notchedOutline {
		border-color: transparent;
	}

	& .inputRoot {
		color: ${border};
		font-family: 'Roboto', sans-serif;
	}
	& .inputFocused {
		color: ${primaryBlue};
	}
	& .inputError {
		color: ${p => (p.disabled ? 'transparent' : primaryRed)};
	}
`;
